<template>
  <div>
    <p class="headline font-weight-bold">UserName</p>
    <v-tabs class="pt-6 mt-5" grow color="red" @change="tab => { this.CurrentIndex = tab;}" style="border-top:solid black 3px;">
      <v-tab>Profile</v-tab>
      <v-tab>Articles</v-tab>
      <v-tab>Comments</v-tab>
      <v-tab-item class="pt-6 mt-5" style="border-top:solid black 3px;">
        <UserProfile></UserProfile>
      </v-tab-item>
      <v-tab-item class="pt-6 mt-5" style="border-top:solid black 3px;">
        <UserArticles></UserArticles>
      </v-tab-item>
      <v-tab-item class="pt-6 mt-5" style="border-top:solid black 3px;">
        <UserComments></UserComments>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import UserProfile from "@/pages/user/Profile.vue"
import UserArticles from "@/pages/user/Articles.vue"
import UserComments from "@/pages/user/Comments.vue"
export default {
  components:{
    UserProfile,
    UserArticles,
    UserComments
  },
  data(){
    return{

    }
  }
}
</script>
